export type ActiveStripeAccountStatus = 'onboarding' | 'pending' | 'readyToUse';

const ACTIVE_STRIPE_ACCOUNT_STATUSES = new Set<ActiveStripeAccountStatus>(['onboarding', 'pending', 'readyToUse']);

/** Returns true for active Stripe statuses (onboarding, pending, readyToUse). Rejected accounts return false. */
export const hasActiveStripeAccount = (status: string): status is ActiveStripeAccountStatus => {
  return ACTIVE_STRIPE_ACCOUNT_STATUSES.has(status as ActiveStripeAccountStatus);
};
